module.exports = __webpack_public_path__ + "static/media/S1-19-Zagockranozz-cod19.400762aa.png";